import _ from 'lodash';
import { createContext, useEffect, useState } from 'react';

import cmsApi from '../../../../cms_api';

export const BadgesContext = createContext();

// eslint-disable-next-line react/prop-types
export const BadgesProvider = ({ path, name }) => ({ children }) => {
  const [response, setResponse] = useState(null);
  useEffect(() => {
    const query = {
      filter: {
        type: 'Cms::Content::Attribute',
        route: path ? `/${path}` : '/',
        name,
      },
      fields: {
        '*': 'contents',
      },
    };
    cmsApi.get_single_contents(query, Board.build.language).then(data => {
      setResponse(data);
    });
  }, [path, name]);

  const value = _.merge({}, response, { path, name });

  return <BadgesContext.Provider value={value}>{children}</BadgesContext.Provider>;
};
